<template>
    <div class="section">
        <h1 class="overskrift">Innlogging</h1>
        <div class="field">
            <label class="label">Brukernavn</label>
            <div class="control">              
                <input 
                    class="input" 
                    type="text" 
                    name="username" 
                    v-model="input.username" 
                    placeholder="Brukernavn" 
                    style="width: 20%;"
                />
            </div>
            <label class="label" style="margin-top:2em;">Passord</label>
            <div class="control">
                <input 
                    class="input" 
                    type="password" 
                    name="password" 
                    v-model="input.password" 
                    placeholder="Passord" 
                    style="width: 20%;"
                    v-on:keydown.enter="login()"
                />
            </div>            
            <button class="button is-link" v-on:click="this.login" style="margin-top:2em;">Logg inn</button>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data() {
            return {
                input: {
                    username: "",
                    password: ""
                }
            }
        },
        methods: {
            login() {
                if(this.input.username == "admin" && this.input.password == "passord") {
                    this.$store.commit("setAuthentication", true);
                    this.$router.replace({ name: "secure" });
                } else {
                    alert("Brukernavn/passord stemmer ikke!");
                }
            }
        }
    }
</script>

<style scoped></style>